// One per order (prompt 93; replaces Minmaxify). Products listed in Theme settings → Cart → "One per order"
// (window.SSC_ONE_PER, snippets/scripts.liquid): all sizes together count as 1.
// - PDP / quick add / sticky bar: once one is in the cart, the Add button reads "Already in your cart" and does nothing
//   (CSS swaps the label; the quantity is already fixed at 1 in the markup), with an "Open cart" link under it.
// - Cart: any route that ends with more than 1 (add.js twice, /cart/add?quantity=3, an old tab) is set back to 1 on cart
//   load or update via /cart/update.js, with a short toast. The drawer, count and offer bar refresh on the same
//   shopify:cart:lines-update event the bundler uses; /cart reloads once.
(function () {
  var list = window.SSC_ONE_PER || [];
  if (!list.length) return;
  var set = {};
  list.forEach(function (h) { set[h] = true; });
  var inCart = {};
  var fixing = false;

  function scopes() { return document.querySelectorAll('[data-ssc-one-per]'); }
  function blocked(node) {
    var scope = node.closest('[data-ssc-one-per]');
    if (scope) return inCart[scope.getAttribute('data-ssc-one-per')] ? scope : null;
    if (node.closest('[data-ssc-sticky]')) {
      var pdp = document.querySelector('[data-ssc-pdp] [data-ssc-one-per]');
      return pdp && inCart[pdp.getAttribute('data-ssc-one-per')] ? pdp : null;
    }
    return null;
  }

  function paint() {
    var pdpHandle = null;
    scopes().forEach(function (scope) {
      var h = scope.getAttribute('data-ssc-one-per');
      var on = !!inCart[h];
      scope.classList.toggle('is-one-in-cart', on);
      scope.querySelectorAll('[data-ssc-add]').forEach(function (b) { if (on) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled'); });
      if (scope.closest('[data-ssc-pdp]')) pdpHandle = h;
    });
    var sticky = document.querySelector('[data-ssc-sticky]');
    if (sticky) {
      var on = !!(pdpHandle && inCart[pdpHandle]);
      sticky.classList.toggle('is-one-in-cart', on);
      var sb = sticky.querySelector('[data-ssc-sticky-add]');
      if (sb) { if (on) sb.setAttribute('aria-disabled', 'true'); else sb.removeAttribute('aria-disabled'); }
    }
  }

  var toastEl = null, toastTimer = 0;
  function toast(text) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ssc-one-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = text;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 5000);
  }
  function label(title) { return /mystery/i.test(title || '') ? 'Mystery shorts' : title; }

  function onCart(cart) {
    inCart = {};
    var seen = {}, updates = {}, names = [], need = false;
    (cart.items || []).forEach(function (it) {
      if (!set[it.handle]) return;
      inCart[it.handle] = true;
      var keep = seen[it.handle] ? 0 : 1;
      seen[it.handle] = true;
      if (it.quantity !== keep) { updates[it.key] = keep; need = true; if (names.indexOf(label(it.product_title)) === -1) names.push(label(it.product_title)); }
    });
    paint();
    if (!need || fixing) return;
    fixing = true;
    var msg = names.join(', ') + ': 1 per order';
    var req = fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
      .then(function (r) { if (!r.ok) throw new Error('cart update ' + r.status); return r.json(); });
    if (/^\/cart\/?$/.test(location.pathname)) {
      req.then(function () {
        try { sessionStorage.setItem('ssc-one-toast', msg); } catch (e) {}
        location.reload();
      }).catch(function () { fixing = false; });
      return;
    }
    var ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
    ev.action = 'update';
    ev.promise = req.then(function () { return { detail: { action: 'update' } }; });
    req.then(function () { toast(msg); document.dispatchEvent(ev); }).catch(function () {}).then(function () { setTimeout(function () { fixing = false; }, 1500); });
  }

  var seq = 0;
  function check(after) {
    var mine = ++seq;
    var run = function () {
      fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) { if (mine === seq) onCart(cart); }).catch(function () {});
    };
    if (after && typeof after.then === 'function') after.then(run, run); else run();
  }

  // An add or change anywhere (theme forms, quick add, bundler, drawer +/−) → recheck once it has landed.
  document.addEventListener('shopify:cart:lines-update', function (e) { check(e && e.promise); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) check(); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') check(); });
  // Quick add markup arrives later: paint it with what we know.
  new MutationObserver(function (m) { for (var i = 0; i < m.length; i++) if (m[i].addedNodes.length) { paint(); break; } }).observe(document.body, { childList: true, subtree: true });

  // "Already in your cart" buttons do nothing; capture phase so the theme's own add handlers never see the click.
  document.addEventListener('click', function (e) {
    var t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    var open = t.closest('[data-ssc-one-open]');
    if (open) {
      e.preventDefault();
      var dlg = open.closest('dialog');
      if (dlg && typeof dlg.close === 'function' && dlg.open) dlg.close();
      var drawer = document.querySelector('#cart-drawer');
      if (drawer && typeof drawer.open === 'function') setTimeout(function () { drawer.open(); }, dlg ? 150 : 0); else location.href = '/cart';
      return;
    }
    var add = t.closest('[data-ssc-add], [data-ssc-sticky-add]');
    if (add && blocked(add)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target instanceof Element ? e.target : null;
    if (f && blocked(f)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  try {
    var pending = sessionStorage.getItem('ssc-one-toast');
    if (pending) { sessionStorage.removeItem('ssc-one-toast'); toast(pending); }
  } catch (e) {}
  check();
})();
